import { textos } from '@/constants/Dimens';
import { Typography } from '@mui/material';

//Definimos los tipos de datos que va a recibir el componente en forma de interfaz
interface TituloH1Props {
    children?: React.ReactNode;
    color?: string;
    icon?: React.ReactNode;
    styleText?: React.CSSProperties;
}

function TituloDescripcion({ children, color, icon, styleText }: TituloH1Props) {
    //Tamaño de texto a 25 px
    //Color de texto a primario

    const style: React.CSSProperties = {
        fontSize: textos,
        color: color ? color : 'black',
        userSelect: 'none',
        textDecoration: 'none',
        fontWeight: '400',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    };


    return (
        <div style={{ display: 'flex' }}>
            {icon && <div style={{ width: "30px", height: "30px" }}>{icon}</div>}
            <Typography style={{ ...style, ...styleText }}>
                {children}
            </Typography>
        </div>
    );
}

export default TituloDescripcion;